angular.module('bribac.entities.subjectFactory', [])

  .value('subjectFactory', function subjectFactory(data) {
    return angular.merge({
      // Inherited from Identity.

      id: null,
      firstName: null,
      lastName: null,
      fullName: null,
      address: null,
      postalCode: null,
      city: null,
      phone: null,
      email: null,
      ssn: null,
      locale: 'en',
      roles: ['ROLE_SUBJECT'],

      // Subject specific.

      tests: [],
      subGroup: null,
      ruleSet: null,
      schedulePeriods: [],
      timeZone: null,
      active: null,
      notes: [],
      highlight: null,
      photos: [],
      agent: null,
      externalMonitors: []
    }, data)
  })
